var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xl"},[_vm._v("\n ...redirecting to home page\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }